import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
  standalone: false
})
export class LoadingIndicatorComponent implements OnInit {
  @Input() theme: string;
  @Input() showEllipsisLoader = false;
  fakeArray = new Array(12);

  constructor() {}

  ngOnInit() {
    if (this.showEllipsisLoader) {
      this.fakeArray = new Array(4);
    }
  }
}
